import useHttpClient from 'hooks/useHttpClient';
import { useMutation } from '@tanstack/react-query';
import { awsS3ApiPath, awsS3PrivateBucketName } from 'configs/variables';

export function useS3Download(props) {
  const { post } = useHttpClient();

  return useMutation({
    mutationFn: async (payload) => {
      const newPayload = {
        module: payload.module,
        group: payload.group,
        file_extension: payload.fileExtension,
        file_name: payload.fileName,
        bucket_name: awsS3PrivateBucketName,
        expires_in: 3600,
      };

      return await post({ url: awsS3ApiPath + '/download', payload: newPayload });
    },
    onSuccess(response) {
      if (response.statusCode !== 200) {
        props?.onError?.();
        return;
      }

      props?.onSuccess?.(response.body);
      return response.body;
    },
    onError() {
      props?.onError?.();
    },
  });
}
